import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ImagesApi } from '../../../api/images/images.api';

/**
 * @deprecated DEPRECATED!!!
 *
 * Use Media service with "public" access type
 *
 * */
@Injectable()
export class ImagesService {
    /**
     * Class constructor
     */
    constructor(
        private imagesApi: ImagesApi
    ) {
    }

    /**
     * Save image data
     *
     * @param encodedImage Image as base64 encoded string
     */
    public saveImage(encodedImage: string): Observable<string> {
        const image = this.imagesApi.performSaveImage(encodedImage);
        return image.pipe(map(
            response => {
                return this.buildImageUrl(response);
            }
        ));
    }

    /**
     * Get the fully qualified URL needed to view the specified image
     *
     * @param imageResponse
     */
    private buildImageUrl(imageResponse): string {
        return this.imagesApi.getUrl(imageResponse);
    }
}
